import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import firebase from "firebase/compat/app";
import { Provider } from "react-redux";
import { getAnalytics } from "firebase/analytics";
import App from "./App";
import "antd/dist/antd.css";
import store from "./redux";
import reportWebVitals from "./reportWebVitals";

const firebaseConfig = {
  apiKey: "AIzaSyDrIK51_A_Q21-lwtv7j-r3S7XenW6oY_U",
  authDomain: "sprinkler-7ba54.firebaseapp.com",
  databaseURL: "https://sprinkler-7ba54.firebaseio.com",
  projectId: "sprinkler-7ba54",
  storageBucket: "sprinkler-7ba54.appspot.com",
  messagingSenderId: "744621462874",
  appId: "1:744621462874:web:6f9aa5e6148c87fbe68f63",
  measurementId: "G-DRMPS2ZCS9",
};
const app = firebase.initializeApp(firebaseConfig);
getAnalytics(app);

ReactDOM.render(
  <Provider store={store || {}}>
    <React.StrictMode>
      <BrowserRouter basename="/web">
        <App />
      </BrowserRouter>
    </React.StrictMode>
  </Provider>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
